import(/* webpackMode: "eager", webpackExports: ["DevQuickLogin"] */ "/srv/stocks-in-global/apps/web/app/(auth)/login/dev-quick-login.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PasswordField"] */ "/srv/stocks-in-global/apps/web/app/(auth)/login/password-field.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignInSubmitButton"] */ "/srv/stocks-in-global/apps/web/app/(auth)/login/submit-button.tsx");
;
import(/* webpackMode: "eager" */ "/srv/stocks-in-global/apps/web/components/demo-quick-login.tsx");
;
import(/* webpackMode: "eager" */ "/srv/stocks-in-global/node_modules/.pnpm/next@15.5.28_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_@types+node@22.19.19_react-dom@_5adenjdaadlbp72pm2heay6q7u/node_modules/next/dist/client/app-dir/link.js");
